import {
  assistantCodegenArtifactRequestSchema,
  type AssistantCodegenArtifact,
} from "@/wab/shared/copilot/assistant-codegen-artifact";
import {
  assistantCodegenFamilyRequestSchema,
  type AssistantCodegenFamilyResult,
} from "@/wab/shared/copilot/assistant-codegen-family";
import { z } from "zod";

const identity = {
  jobId: z.string().min(1).max(128),
  prepareCallId: z.string().min(1).max(256),
  executeCallId: z.string().min(1).max(256),
};
export const assistantCodegenJobPrepareSchema = z
  .object({
    ...identity,
    request: z.union([
      assistantCodegenArtifactRequestSchema,
      assistantCodegenFamilyRequestSchema,
    ]),
  })
  .strict();
export const assistantCodegenJobReferenceSchema = z
  .object({
    ...identity,
    requestDigest: z.string().regex(/^[a-f0-9]{64}$/),
    projectId: z.string().min(1).max(128),
  })
  .strict();
export const assistantCodegenJobListSchema = z
  .object({
    projectId: z.string().min(1).max(128),
    expectedContext: z.string().min(1).max(256),
    limit: z.number().int().min(1).max(100),
  })
  .strict();
export type CodegenJobPrepare = z.infer<
  typeof assistantCodegenJobPrepareSchema
>;
export type CodegenJobRequest = CodegenJobPrepare["request"];
export type CodegenJobArtifact =
  AssistantCodegenArtifact | AssistantCodegenFamilyResult;
export type CodegenJobReference = z.infer<
  typeof assistantCodegenJobReferenceSchema
>;
export interface CodegenJobReceipt extends CodegenJobReference {
  schemaVersion: 1;
  kind: "codegen_artifact";
  actorUserId: string;
  attemptId: string;
  artifactSha256: string;
  manifestSha256: string;
}
export interface CodegenJobResult {
  reference: CodegenJobReference;
  state: "prepared" | "outcome_unknown" | "applied" | "cancelled";
  receipt: CodegenJobReceipt | null;
  artifact: CodegenJobArtifact | null;
}
